export default {
  "common.operation.ok": "Ok",
  "common.operation.add": "Add ",
  "common.operation.new": "New ",
  "common.operation.edit": "Edit ",
  "common.operation.view": "View ",
  "common.operation.copy": "Copy ",
  "common.operation.cancel": "Cancel ",
  "common.operation.delete": "Delete ",
  "common.operation.deleteTips": "Are you sure to delete?",
  "common.operation.back": "Back ",
  "common.operation.save": "Save ",
  "common.operation.submit": "Submit ",
  "common.operation.processing": "Processing",
  "common.operation.completed": "Completed",
  "common.operation.creating": "Creating",
  "common.operation.created": "Created",
  "common.operation.more": "More ",
  "common.operation.print": "Print ",
  "common.operation.share": "Share ",
  "common.operation.detail": "Detail",
  "common.operation.import": "Import ",
  "common.operation.export": "Export ",
  "common.operation.search": "Search ",
  "common.operation.upload": "Upload ",
  "common.operation.option": "Option",
  "common.operation.download": "Download",
  "common.operation.request": "Request ",
  "common.operation.operate": "Operate",
  "common.operation.confirm": "OK ",
  "common.operation.setting": "Setting ",
  "common.operation.generate": "Generate ",
  "common.operation.open": "Open",
  "common.operation.close": "Close",
  "common.operation.modify": "Modify ",
  "common.operation.reset": "Reset",
  "common.form.input.tips": "Please Enter ",
  "common.form.date.tips": "Please Select ",
  "common.form.select.tips": "Please Select ",
  "common.request.succeed": "Successfully",
  "common.request.failed": "Failed, please try again later",
  "common.request.error": "The request failed. Please try again later",
  "common.gender": "Gender",
  "common.gender.male": "Male",
  "common.gender.Male": "Male",
  "common.gender.female": "Female",
  "common.gender.Female": "Female",
  "common.gender.unknown": "unknown",
  "common.gender.Unknown": "Unknown",
  "common.user.name": "Supports: Chinese characters, English letters, and Spaces",
  "common.user.account": "Supports:  letters, and number",
  "common.user.special.character": "Special characters cannot be entered",
  "common.columns.name": "Name",
  "common.columns.creator": "Creator",
  "common.columns.age": "Age",
  "common.columns.status": "Status",
  "common.columns.type": "Type",
  "common.columns.content": "Content",
  "common.columns.updateTime": "Update Time",
  "common.columns.starTime": "Start Time",
  "common.valueEnum.system": "System",
  "common.valueEnum.custom": "Custom",
  "common.valueEnum.enable": "Enable",
  "common.valueEnum.disable": "Disable",
  "common.step.next": "Next",
  "common.step.prev": "Previous",
  "common.tips.noData": "No Data",
  "common.abnormality.normal": "Normal",
  "common.abnormality.abnormal": "Abnormal",
  "common.abnormality.low": "Low",
  "common.abnormality.high": "High",
  "common.abnormality.negative": "Negative",
  "common.abnormality.positive": "Positive",
  "common.groupReport.referenceRange.min": "Lower",
  "common.groupReport.referenceRange.normal": "Normal",
  "common.groupReport.referenceRange.high": "Normal High",
  "common.groupReport.referenceRange.max": "Higher",
  "common.groupReport.referenceRange.lean": "Leaner",
  "common.groupReport.referenceRange.overweight": "Overweight",
  "common.groupReport.referenceRange.fat": "Fat",
  "common.option.true": "True",
  "common.option.false": "False",
  "common.request.submit.success": 'Submit Success',
  "common.request.submit.loading": 'Submitting ',
  "common.request.submit.fail": 'Submit failed, please try again',
  "common.request.delete.success": 'Delete Success',
  "common.request.delete.loading": 'Deleting',
  "common.request.delete.fail": 'Delete failed, please try again',
  "common.request.enable.success": 'Enable Success',
  "common.request.enable.loading": 'Enabling',
  "common.request.enable.fail": 'Delete failed, please try again',
  "common.request.disable.success": 'Disable Success',
  "common.request.disable.loading": 'Disabling',
  "common.request.disable.fail": 'Delete failed, please try again',
  "common.time.early": "EMT",
  "common.time.morning": "AM",
  "common.time.afternoon": "PM",
  "common.time.evening": "Night",
  "common.timeUnit.year": " year",
  "common.timeUnit.month": " month",
  "common.timeUnit.day": " day",
  "common.timeUnit.hour": " hour",
  "common.timeUnit.minute": " minute",
  "common.timeUnit.second": " second",
  "common.timeUnit.Year": "Year",
  "common.timeUnit.Month": "Month",
  "common.timeUnit.Day": "Day",
  "common.timeUnit.Hour": "Hour",
  "common.timeUnit.Minute": "Minute",
  "common.timeUnit.Second": "Second",
  "common.table.column.sort": "sort",
  "common.table.column.Sort": "Sort",
}
